
































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
// @ts-ignore
import qs from 'qs'
// @ts-ignore
import isURL from 'validator/lib/isURL'
import UploadButton from './UploadButton.vue'

import { Media } from '../store/timeline'
import config from '../config'

const validateURL = (s: string) => isURL(s || '', {
    protocols: ['http','https'],
    require_tld: true,
    require_protocol: true,
    require_host: true,
    require_valid_protocol: true,
    allow_underscores: false,
    host_whitelist: false,
    host_blacklist: false,
    allow_trailing_dot: false,
    allow_protocol_relative_urls: false,
})

@Component({
    components: {
        UploadButton,
    },
    props: {
        editing: {
            type: Boolean,
            required: true,
        },
        medias: {
            type: Array,
            required: true,
        },
    },
})
export default class TimeField extends Vue {
    videoMenu = false
    videoUrl = ''
    videoValid = true
    urlRules = [
        (v: any) => v ? true : 'This field is required',
        (v: string) => validateURL(v) ? true : 'Invalid HTTP(S) URL',
    ]
    onUpload(upload: any) {
        this.$emit('addImage', upload)
    }
    onAddVideoCancel() {
        this.videoMenu = false
    }
    onAddVideo() {
        this.$emit('addVideo', this.videoUrl)
        this.videoMenu = false
    }
    onRemoveMedia(mediaIndex: number) {
        this.$emit('removeMedia', mediaIndex)
    }
    @Watch('videoMenu')
    videoMenuChanged(videoMenu: boolean) {
        if (!videoMenu) {
            const form: any = this.$refs.videoForm
            form.reset()
        }
    }
    getMediaImage(media: Media) {
        if (media.image_url) {
            return media.image_url
        }
        if (media.video_url) {
            const parser = document.createElement('a')
            parser.href = media.video_url
            console.log(parser.hostname, parser.pathname, parser.search)
            if (parser.hostname === 'www.youtube.com' && parser.pathname === '/watch') {
                const q = qs.parse(parser.search.substr(1))
                return `https://img.youtube.com/vi/${q.v}/0.jpg`
            }
        }
        return undefined
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MediaTab.vue